export const strengthData = {
  label: "WHY I WOULD MAKE A GREAT ADDITION TO YOUR TEAM",

  sections: [
    {
      title: "Technical Expertise",
      description:
        "Strong foundation in React, Angular, and TypeScript with hands-on experience building scalable ERP workflows, dashboards, and reusable component architectures. Skilled in API integration, state management (Redux, RxJS, Context API), authentication systems, and transforming complex Figma designs into high-performance, production-ready UI using Tailwind CSS and Material UI."
    },
    {
      title: "Design & Product Thinking",
      description:
        "Focused on creating responsive, accessible, and user-centric interfaces that balance aesthetics with performance. Experienced in Figma and design systems, ensuring visual consistency and intuitive user experiences across products."
    },
    {
      title: "Leadership & Ownership",
      description:
        "Demonstrated leadership as a Web Dev Lead mentoring 500+ students and coordinating 20+ events. Proactive in taking end-to-end ownership of features while collaborating effectively with cross-functional teams to deliver high-quality, maintainable solutions."
    },
  ],
};